module.exports = __webpack_public_path__ + "763b0594f836c83e669a3acda1183957.svg";